export default "__VITE_ASSET__Dm01TyBq__"